import { FormGroup } from '@angular/forms';
import { GeneralResponse } from 'src/app/global/interfaces/general-response';

export abstract class AuthVMService {

    run: number;

    abstract auth(form: FormGroup, isMobile: boolean): Promise<GeneralResponse<any>>;

    abstract authLogin(form: FormGroup, isMobile: boolean): Promise<GeneralResponse<any>>;

    abstract authPersonaNatural(form: FormGroup, isMobile: boolean): Promise<GeneralResponse<any>>;

    abstract createForm(): FormGroup;

    abstract createSocioCIForm(): FormGroup;

    abstract createLoginForm(): FormGroup;

    //TODO: Eliminar Login Unificado
    abstract createLoginEmpresaForm(): FormGroup;

    abstract createLoginUnificadoForm(): FormGroup;

    abstract initCaptcha();

    abstract isClientDialog();

    abstract ssEnCursoDialog(response: GeneralResponse<any>);

    abstract unfinishedTripBefore42DaysDialog();

    abstract bloquedAccountDialog(form: FormGroup);

    abstract validarContenido(response: GeneralResponse<any>, form: FormGroup);
}
